import { useCallback } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";

function isWorkdeskClientPath(pathname) {
  return /^\/hub\/[^/]+\/workdesk(\/|$)/.test(pathname);
}

function parentPathToIframePath(pathname) {
  const withClients = pathname.replace(
    /^(\/hub\/[^/]+)\/workdesk\/clients\//,
    "$1/clients/"
  );
  if (withClients !== pathname) {
    return withClients;
  }
  return pathname.replace(/^(\/hub\/[^/]+)\/workdesk\/?$/, "$1");
}

function iframePathToWorkdeskParentPath(pathname) {
  if (pathname.includes("/workdesk/")) {
    return pathname;
  }
  return pathname.replace(/^(\/hub\/[^/]+)\/clients\//, "$1/workdesk/clients/");
}

export function useWorkDesk() {
  const history = useHistory();
  const location = useLocation();
  const { hubId } = useParams();

  const openWorkDesk = useCallback(() => {
    if (!hubId) {
      return;
    }
    const { pathname, search } = location;
    const q = search || "";
    if (
      pathname.includes("/clients/") &&
      !pathname.includes("/workdesk/clients/")
    ) {
      history.replace(iframePathToWorkdeskParentPath(pathname) + q);
    } else {
      history.replace(`/hub/${hubId}/workdesk${q}`);
    }
  }, [history, hubId, location]);

  return {
    openWorkDesk: openWorkDesk,
    parentPathToIframePath: parentPathToIframePath,
    iframePathToWorkdeskParentPath: iframePathToWorkdeskParentPath,
    isWorkdeskClientPath: isWorkdeskClientPath(location.pathname),
  };
}

export default useWorkDesk;
